import { __exports as t } from "../../../../_virtual/useMemo.mjs";
import "../../../@babel/runtime/helpers/interopRequireWildcard.mjs";
import a from "react";
import { exports as i } from "../../../../_virtual/interopRequireWildcard.mjs";
var c = i.default;
Object.defineProperty(t, "__esModule", {
  value: !0
});
t.default = f;
var n = c(a);
function f(u, r, o) {
  var e = n.useRef({});
  return (!("value" in e.current) || o(e.current.condition, r)) && (e.current.value = u(), e.current.condition = r), e.current.value;
}
//# sourceMappingURL=useMemo.mjs.map
